export function createAuthStore() {
  return {
    user: JSON.parse(localStorage.getItem('opshub_user') || 'null'),
    accessToken: localStorage.getItem('opshub_access_token') || null,
    refreshToken: localStorage.getItem('opshub_refresh_token') || null,
    currentWorkspaceId: localStorage.getItem('opshub_workspace_id') || null,
    workspaces: [],

    get isAuthenticated() {
      return this.accessToken !== null && this.user !== null;
    },

    setTokens(accessToken, refreshToken) {
      this.accessToken = accessToken;
      this.refreshToken = refreshToken;
      localStorage.setItem('opshub_access_token', accessToken);
      localStorage.setItem('opshub_refresh_token', refreshToken);
    },

    setUser(user) {
      this.user = user;
      localStorage.setItem('opshub_user', JSON.stringify(user));
    },

    get isAdmin() {
      return this.user?.platform_roles?.includes('super_admin') ?? false;
    },

    setWorkspace(workspaceId) {
      this.currentWorkspaceId = workspaceId;
      localStorage.setItem('opshub_workspace_id', workspaceId);
    },

    logout() {
      this.user = null;
      this.accessToken = null;
      this.refreshToken = null;
      this.currentWorkspaceId = null;
      this.workspaces = [];
      localStorage.removeItem('opshub_user');
      localStorage.removeItem('opshub_access_token');
      localStorage.removeItem('opshub_refresh_token');
      localStorage.removeItem('opshub_workspace_id');
      window.location.hash = '/login';
    },
  };
}
